var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountShape(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98499 14.6604L2.465 13.1404C1.845 12.5204 1.845 11.5004 2.465 10.8804L3.98499 9.36039C4.24499 9.10039 4.45499 8.59038 4.45499 8.23038V6.08036C4.45499 5.20036 5.175 4.48038 6.055 4.48038H8.20499C8.56499 4.48038 9.075 4.27041 9.335 4.01041L10.855 2.49039C11.475 1.87039 12.495 1.87039 13.115 2.49039L14.635 4.01041C14.895 4.27041 15.405 4.48038 15.765 4.48038H17.915C18.795 4.48038 19.515 5.20036 19.515 6.08036V8.23038C19.515 8.59038 19.725 9.10039 19.985 9.36039L21.505 10.8804C22.125 11.5004 22.125 12.5204 21.505 13.1404L19.985 14.6604C19.725 14.9204 19.515 15.4304 19.515 15.7904V17.9403C19.515 18.8203 18.795 19.5404 17.915 19.5404H15.765C15.405 19.5404 14.895 19.7504 14.635 20.0104L13.115 21.5304C12.495 22.1504 11.475 22.1504 10.855 21.5304L9.335 20.0104C9.075 19.7504 8.56499 19.5404 8.20499 19.5404H6.055C5.175 19.5404 4.45499 18.8203 4.45499 17.9403V15.7904C4.45499 15.4204 4.24499 14.9104 3.98499 14.6604Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4945 14.5H14.5035",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49451 9.5H9.50349",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discount-shape.9d9702c3148d98ab3143a4dc1db699d5.svg";
export { ForwardRef as ReactComponent };